import { formatArea, getLocaleByCountry } from '../../../../../utils/strings';

// @flow
export const areaToObject = (areas: Array<number>, intl: Object, country: Object) => {
  const obj = {};
  areas.forEach(area => {
    obj[area] = formatArea(area, intl, getLocaleByCountry(country));
  });
  return obj;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/areaToObject.js